import React from 'react';
import './logo.css';

const Logo = () => {
    return (
        <>
        <h1 className='mylogo'>MovieHub</h1>
        </>
    )
}

export default Logo;